import React from "react";

// Custom TitleFieldTemplate that hides the form title since logo is displayed separately
const TitleFieldTemplate = () => {
  // Return null to hide the title (logo is rendered outside the form)
  return null;
};

export default TitleFieldTemplate;
